export const roleConstants = {
    ROLE_FETCHING: 'ROLE_FETCHING',
    ROLE_FETCHED: 'ROLE_FETCHED',
    GET_ACTIVE_ROLES: 'GET_ACTIVE_ROLES',
    GET_ROLES: 'GET_ROLES',
    GET_ROLE_BY_ID: 'GET_ROLE_BY_ID',
    UPDATE_ROLE: 'UPDATE_ROLE',
    SEARCH_ROLE: 'SEARCH_ROLE',
}